<div class="time-picker-time-zone-picker-wrap">
  <div class="time-zone-header" (click)="$event.preventDefault(); $event.stopPropagation()">
    <rt-form-field>
      <rt-input
        #searchInput
        [autoFocus]="true"
        [hasClearButton]="!isEmpty"
        (input)="onInputChange($event)"
        (click)="$event.preventDefault()"
        (reset)="clearField()"
        variant="rounded"
        placeholder="{{ 'rtu.time_zone.search_placeholder' | translate }}"
      >
        <rt-icon prefix name="search"></rt-icon>
      </rt-input>
    </rt-form-field>
  </div>
  <div class="zones-list-container">
    <rt-dropdown-item
      *ngFor="let zone of filteredZones; trackBy: trackByZone"
      (click)="zoneSelect.emit(zone.timezone)"
      class="zone-item clickable"
    >
      {{ zone.timezoneFormatted }}
    </rt-dropdown-item>
    <rt-dropdown-item *ngIf="!filteredZones.length" class="zone-item">
      {{ 'rtu.ui.select.no_results' | translate }}
    </rt-dropdown-item>
  </div>
</div>
